import { memo } from "react";
import PropTypes from "prop-types";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import classNames from "classnames";
import "./PhotoArticle.scss";
import Paragraphs from "app/pages/.shared/Paragraphs";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const IMG_SIZES = {
	large: { width: 270, height: 229 },
	xlarge: { width: 270, height: 229 },
	medium: { width: 710 },
	small: { width: 500 },
};

const PhotoArticle = ({
	text,
	title,
	photoPosition,
	desktopPhoto,
	desktopPhotoThumbnail,
	mobilePhoto,
	mobilePhotoThumbnail,
	isMobile,
	sticker,
}) => {
	const blockClassName = classNames("photo-article", {
		"photo-article--reverse": photoPosition === "right",
	});

	return (
		<div className={blockClassName}>
			<div className="photo-article__photo">
				{isMobile ? (
					<ProgressiveImg
						sizes={IMG_SIZES}
						thumbnail={mobilePhotoThumbnail}
						src={mobilePhoto}
					/>
				) : (
					<BackgroundProgressiveImg
						sizes={IMG_SIZES}
						cloudinaryOptions={["c_fill", "g_auto"]}
						thumbnail={desktopPhotoThumbnail}
						backgroundPosition="center"
						src={desktopPhoto}
					/>
				)}
			</div>
			<div className="photo-article__content">
				{sticker && (
					<img
						className="photo-article__sticker"
						src={sticker}
						width={isMobile ? 80 : 105}
						height={isMobile ? 80 : 105}
					/>
				)}
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL2}
					isBold
					className="photo-article__title"
					component="h3"
				>
					<Paragraphs paragraphs={title} enableHTMLFormatting />
				</Typography>

				<div className="photo-article__text">
					<Paragraphs paragraphs={text} enableHTMLFormatting />
				</div>
			</div>
		</div>
	);
};

PhotoArticle.propTypes = {
	sticker: PropTypes.string,
	text: PropTypes.string,
	title: PropTypes.string,
	photoPosition: PropTypes.string,
	desktopPhoto: PropTypes.string,
	mobilePhoto: PropTypes.string,
	desktopPhotoThumbnail: PropTypes.string,
	mobilePhotoThumbnail: PropTypes.string,
	isMobile: PropTypes.bool,
};

export default memo(PhotoArticle);
